import { useMutation, useQueryClient } from 'react-query'
import { QUERY_KEYS } from 'src/constants'
import { settingsService } from 'src/services/settings.service'
import { ISettingsRespDto, IUpdateSettingsSwitchDto } from 'src/types'

export const useUpdateSpowJourneyHomePageSetting = () => {
  const queryClient = useQueryClient()

  return useMutation(
    (dto: IUpdateSettingsSwitchDto) => settingsService.updateShowJourneyHomePage(dto),
    {
      onSuccess(data, vars) {
        if (!data) {
          return
        }

        queryClient.setQueryData([QUERY_KEYS.SETTINGS], (prev?: ISettingsRespDto) => {
          if (!prev) {
            return undefined as unknown as ISettingsRespDto
          }

          return { ...prev, show_journey_home_page: vars.enabled }
        })
      },
    },
  )
}
